import { render, staticRenderFns } from "./ModelTreeDialogVk.vue?vue&type=template&id=3dd57243&scoped=true"
import script from "./ModelTreeDialogVk.vue?vue&type=script&lang=js"
export * from "./ModelTreeDialogVk.vue?vue&type=script&lang=js"
import style0 from "./ModelTreeDialogVk.vue?vue&type=style&index=0&id=3dd57243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd57243",
  null
  
)

export default component.exports